// extracted by mini-css-extract-plugin
module.exports = {"root":"DataViewHeader_root","inner":"DataViewHeader_inner"};